@if (showSeparator()) {
  <pc-separator></pc-separator>
}
<section>
  <pc-quote-overview-trip-details
    [destinationsToggleOptions]="destinationsToggleOptions()"
    [quoteTripDetailsData]="quoteTripDetailsData()"
    [selectedDestinationAlt]="selectedDestinationAlt()"
    [travelersAmountText]="travelersAmountText()"
    [tripDetailsIcons]="tripDetailsIcons()"
  >
  </pc-quote-overview-trip-details>
  <pc-separator></pc-separator>

  <pc-quote-overview-cover-section [quoteCoversData]="quoteCoversData()"></pc-quote-overview-cover-section>

  @if (showBrokerFeeSection()) {
    <pc-separator></pc-separator>
    <pc-quote-overview-broker-section
      [gstRate]="gstRate() || 0"
      [sectionTexts]="brokerFeeTexts()"
      [(fee)]="brokerFee"
    ></pc-quote-overview-broker-section>
  }

  @if (showEmailSection()) {
    <pc-separator></pc-separator>
    <pc-quote-overview-email
      [emailTexts]="emailQuoteTexts()"
      [privacyPolicyLink]="privacyPolicyLink()"
    ></pc-quote-overview-email>
  }
</section>
